import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TwoColumnListContentLayoutModule } from 'src/app/common-components/column-layouts/two-column-list-layout/two-column-list-layout.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatNameLengthPipeModule } from 'src/app/pipes/format-name-length-pipe/call-cost-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { ModifyScheduleModule } from '../modify-schedule/modify-schedule.module';
import { ScheduleDetailModule } from '../schedule-details/schedule-detail.module';
import { ScheduleRegisterComponent } from './containers/schedule-register.component';
import { ScheduleWrapperComponent } from './containers/schedule-wrapper.component';
import { ScheduleRegisterEffects } from './state/schedule-register.effects';
import { scheduleRegisterFeatureKey, scheduleRegisterReducer } from './state/schedule-register.reducer';
import { ScheduleRegisterViewComponent } from './views/schedule-register-view.component';

@NgModule({
   declarations: [ScheduleRegisterComponent, ScheduleRegisterViewComponent, ScheduleWrapperComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatMenuModule,
      TwoColumnListContentLayoutModule,
      MatButtonModule,
      AddSpacesPipeModule,
      ScheduleDetailModule,
      MatInputModule,
      MatTooltipModule,
      FormatNameLengthPipeModule,
      MatIconModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      ModifyScheduleModule,
      EffectsModule.forFeature([ScheduleRegisterEffects]),
      StoreModule.forFeature(scheduleRegisterFeatureKey, scheduleRegisterReducer),
   ],
})
export class ScheduleRegisterModule {}
